export default {
  ar() {
    return {
      close: 'غلق',
      continue: 'الإستكمال للدفع',
      keepShopping: 'الاستمرار فى التسوق',
      yourItems: 'العناصر الخاصة بك',
    }
  },

  de() {
    return {
      close: 'Schließen',
      continue: 'Weiter zur Kasse',
      keepShopping: 'Weiter einkaufen',
      yourItems: 'Ihre Artikel',
    }
  },

  en() {
    return {
      close: 'Close',
      continue: 'Continue To Checkout',
      continueGpe: 'Continue To Payment',
      keepShopping: 'Continue Shopping',
      yourItems: 'Your Items',
    }
  },

  enGB() {
    return {
      close: 'Close',
      continue: 'Continue To Checkout',
      continueGpe: 'Continue To Payment',
      keepShopping: 'Continue Shopping',
      yourItems: 'Your Items',
    }
  },

  esMX() {
    return {
      close: 'Cerrar',
      continue: 'Continuar al Pago',
      keepShopping: 'Continuar Comprando',
      yourItems: 'Sus Artículos',
    }
  },

  fr() {
    return {
      close: 'Fermer',
      continue: 'Passer la commande',
      keepShopping: 'Continuer vos achats',
      yourItems: 'Vos articles',
    }
  },

  it() {
    return {
      close: 'Chiudi',
      continue: 'Vai alla cassa',
      keepShopping: 'Continua a fare acquisti',
      yourItems: 'I tuoi articoli',
    }
  },

  ja() {
    return {
      close: '閉じる',
      continue: 'チェックアウトを続ける',
      keepShopping: 'ショッピングを続ける',
      yourItems: 'お客様のアイテム',
    }
  },

  pl() {
    return {
      close: 'zamknij',
      continue: 'przejdź do kasy',
      keepShopping: 'kontynuuj zakupy',
      yourItems: 'zamówione pozycje',
    }
  },

  zhCN() {
    return {
      close: '关闭',
      continue: '继续付款',
      keepShopping: '继续购物',
      yourItems: '您的物品',
    }
  }
}
